import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomIntercomChat = createSvgIcon(
  <path d="M20 21s-2.694-1.043-4.873-1.879H5.964C4.88 19.121 4 18.202 4 17.07V5.05C4 3.919 4.88 3 5.964 3h12.071C19.12 3 20 3.918 20 5.05v10.353zm-2.365-6.74a.5.5 0 0 0-.561-.163.5.5 0 0 0-.177.104c-.018.015-1.723 1.508-4.898 1.508-3.134 0-4.866-1.483-4.897-1.51a.505.505 0 0 0-.58-.07.562.562 0 0 0-.1.903c.08.071 2.02 1.771 5.577 1.771s5.498-1.7 5.58-1.772a.56.56 0 0 0 .057-.771" />,
  'CustomIntercomChat',
);

export default CustomIntercomChat;
